<template functional>
  <div>
    <a
      href="#"
      @click="$options.show(props)"
      :class="[props.row.totalRecharges >= 0 ? 'Negro' : 'Rojo']"
      >{{ $options.formatMonto(props.row.totalRecharges) }}</a
    >
  </div>
</template>

<script>
//import store from "../../../../store/index";
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperlinkForNfcMovilTotalRecargasReport",
  show(ops) {
    ops;
    //console.log("hola", ops)
    ops.row.OpenDetailRecarga(ops.row);
    /*
      store.dispatch("getAllCustomer", {
        empresaid: ops.row.Empresaid
      });
      */
  }
};
</script>

<style>
.Negro {
  color: #606266;
}
</style>
